import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from "vue";
import routesName from "@/utils/constants/routesName";
import { useRoute } from "vue-router";
import { useOrderStore } from "@/store/order";

interface IMenuItems {
  title: string;
  routeName: string;
  icon: string;
  mobileOrder: number;
  count?: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props, { expose }) {
  expose();

const menuItems = computed<IMenuItems[]>(() => [
  {
    title: "Our Services",
    routeName: routesName.services,
    icon: "services",
    mobileOrder: 1,
  },
  {
    title: "About Us",
    routeName: routesName.aboutUs,
    icon: "info",
    mobileOrder: 2,
  },
  {
    title: "Contact Us",
    routeName: routesName.contactUs,
    icon: "phone",
    mobileOrder: 3,
  },
  {
    title: "My order",
    routeName: routesName.order,
    icon: "cart",
    count: totalOrders.value,
    mobileOrder: 0,
  },
]);
const menuItemsMobile = computed<IMenuItems[]>(() =>
  [...menuItems.value].sort((a, b) => a.mobileOrder - b.mobileOrder)
);

const showMenu = ref<boolean>(false);
const toggleMenu = (show: boolean): void => {
  showMenu.value = show;
  if (showMenu.value) {
    document.body.classList.add("no-scroll");
  } else {
    document.body.classList.remove("no-scroll");
  }
};
const route = useRoute();
watch(
  () => route.name,
  (oldV, newV) => {
    if (oldV !== newV) {
      toggleMenu(false);
    }
  }
);

const orderStore = useOrderStore();
const totalOrders = computed<number>(() => orderStore.total.length);

const __returned__ = { menuItems, menuItemsMobile, showMenu, toggleMenu, route, orderStore, totalOrders, computed, ref, watch, routesName, useRoute, useOrderStore }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})